var PropertyRecordsImporterErrors = {

  customers: function(errors) {
    var err = [];

    if (errors.first_name && errors.first_name.length) {
      for (var i = 0, ilen = errors.first_name.length; i < ilen; i++) {
        err.push(I18n.t('first_name') + ' ' + errors.first_name[i]);
      }
    }
    
    if (errors.last_name && errors.last_name.length) {
      for (var i = 0, ilen = errors.last_name.length; i < ilen; i++) {
        err.push(I18n.t('last_name') + ' ' + errors.last_name[i]);
      }
    }

    if (errors.email && errors.email.length) {
      for (var i = 0, ilen = errors.email.length; i < ilen; i++) {
        err.push(I18n.t('email') + ' ' + errors.email[i]);
      }
    }

    return err;
  },

  reservations: function (errors) {
    var err = [];

    if (errors.booked_at && errors.booked_at.length) {
      for (var i = 0, ilen = errors.booked_at.length; i < ilen; i++) {
        err.push(I18n.t('booked_at') + ' ' + errors.booked_at[i]);
      }
    }

    if (errors.booked_at_format && errors.booked_at_format.length) {
      for (var i = 0, ilen = errors.booked_at_format.length; i < ilen; i++) {
        err.push(I18n.t('booked_at') + ' ' + I18n.t('format') + ' ' + errors.booked_at_format[i]);
      }
    }

    if (errors.start_date && errors.start_date.length) {
      for (var i = 0, ilen = errors.start_date.length; i < ilen; i++) {
        err.push(I18n.t('start_date') + ' ' + errors.start_date[i]);
      }
    }

    if (errors.start_date_format && errors.start_date_format.length) {
      for (var i = 0, ilen = errors.start_date_format.length; i < ilen; i++) {
        err.push(I18n.t('start_date') + ' ' + I18n.t('format') + ' ' + errors.start_date_format[i]);
      }
    }

    if (errors.end_date && errors.end_date.length) {
      for (var i = 0, ilen = errors.end_date.length; i < ilen; i++) {
        err.push(I18n.t('end_date') + ' ' + errors.end_date[i]);
      }
    }

    if (errors.end_date_format && errors.end_date_format.length) {
      for (var i = 0, ilen = errors.end_date_format.length; i < ilen; i++) {
        err.push(I18n.t('end_date') + ' ' + I18n.t('format') + ' ' + errors.end_date_format[i]);
      }
    }

    if (errors.email && errors.email.length) {
      for (var i = 0, ilen = errors.email.length; i < ilen; i++) {
        err.push(I18n.t('email') + ' ' + errors.email[i]);
      }
    }

    if (errors.room_type_name && errors.room_type_name.length) {
      for (var i = 0, ilen = errors.room_type_name.length; i < ilen; i++) {
        err.push(I18n.t('room_type_name') + ' ' + errors.room_type_name[i]);
      }
    }

    if (errors.revenue_no_tax && errors.revenue_no_tax.length) {
      for (var i = 0, ilen = errors.revenue_no_tax.length; i < ilen; i++) {
        err.push(I18n.t('revenue_no_tax') + ' ' + errors.revenue_no_tax[i]);
      }
    }

    if (errors.payment_amount && errors.payment_amount.length) {
      for (var i = 0, ilen = errors.payment_amount.length; i < ilen; i++) {
        err.push(I18n.t('payment_amount') + ' ' + errors.payment_amount[i]);
      }
    }

    if (errors.taxes_amount_1 && errors.taxes_amount_1.length) {
      for (var i = 0, ilen = errors.taxes_amount_1.length; i < ilen; i++) {
        err.push(I18n.t('taxes_amount') + ' ' + errors.taxes_amount_1[i]);
      }
    }

    if (errors.tax_name_1 && errors.tax_name_1.length) {
      for (var i = 0, ilen = errors.tax_name_1.length; i < ilen; i++) {
        err.push(I18n.t('tax_name') + ' ' + errors.tax_name_1[i]);
      }
    }

    if (errors.taxes_amount_2 && errors.taxes_amount_2.length) {
      for (var i = 0, ilen = errors.taxes_amount_2.length; i < ilen; i++) {
        err.push(I18n.t('taxes_amount') + ' ' + errors.taxes_amount_2[i]);
      }
    }

    if (errors.tax_name_2 && errors.tax_name_2.length) {
      for (var i = 0, ilen = errors.tax_name_2.length; i < ilen; i++) {
        err.push(I18n.t('tax_name') + ' ' + errors.tax_name_2[i]);
      }
    }

    if (errors.taxes_amount_3 && errors.taxes_amount_3.length) {
      for (var i = 0, ilen = errors.taxes_amount_3.length; i < ilen; i++) {
        err.push(I18n.t('taxes_amount') + ' ' + errors.taxes_amount_3[i]);
      }
    }

    if (errors.tax_name_3 && errors.tax_name_3.length) {
      for (var i = 0, ilen = errors.tax_name_3.length; i < ilen; i++) {
        err.push(I18n.t('tax_name') + ' ' + errors.tax_name_3[i]);
      }
    }

    if (errors.fees_amount && errors.fees_amount.length) {
      for (var i = 0, ilen = errors.fees_amount.length; i < ilen; i++) {
        err.push(I18n.t('fees_amount') + ' ' + errors.fees_amount[i]);
      }
    }
    
    if (errors.fee_name && errors.fee_name.length) {
      for (var i = 0, ilen = errors.fee_name.length; i < ilen; i++) {
        err.push(I18n.t('fee_name') + ' ' + errors.fee_name[i]);
      }
    }

    return err;
  },
};

export default PropertyRecordsImporterErrors
